var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.334,
    height: 17.298,
    viewBox: "0 0 17.334 17.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-outline",
    transform: "translate(-17.723 -17.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M34.091,31.068A14.437,14.437,0,0,0,31.22,29.15c-.956-.482-1.035-.521-1.786.037-.5.373-.834.705-1.421.58a7.61,7.61,0,0,1-2.977-1.943,7.863,7.863,0,0,1-1.988-3.009c-.125-.585.213-.914.582-1.416.52-.708.481-.826.036-1.782a13.074,13.074,0,0,0-1.924-2.864c-.676-.668-.676-.55-1.111-.369a6.3,6.3,0,0,0-1.016.542,3.044,3.044,0,0,0-1.223,1.288c-.244.522-.354,1.746.908,4.038a20,20,0,0,0,3.979,5.291,21.77,21.77,0,0,0,5.3,3.964c2.548,1.427,3.525,1.149,4.048.9a3.035,3.035,0,0,0,1.291-1.219,6.258,6.258,0,0,0,.543-1.015C34.642,31.744,34.76,31.744,34.091,31.068Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#7b7bff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e4e3930297b88dd6583d2e219dd9669a.svg";
export { ForwardRef as ReactComponent };